module.exports = __webpack_public_path__ + "b0bb967778275b356010f01219188eb0.svg";